export default __webpack_public_path__ + "static/media/panels_image2.e69860a7.jpg";